/* theiro product page: <glow-bundles> (1/2/3-ball tiers, mixed sizes) and <tg-sticky> (sticky add to cart).
   Both read from / write to Dawn's main product form; neither owns cart logic. */
(() => {
  const doc = document;
  /* Resolve shared helpers at call time: theiro.js may execute after this file. */
  const tu = () => window.theiroUtil || {};
  const emit = (name, detail = {}) => (tu().emit ? tu().emit(name, detail) : doc.dispatchEvent(new CustomEvent(name, { detail })));
  const formatMoney = (c) => (tu().formatMoney ? tu().formatMoney(c) : `$${(Number(c) / 100).toFixed(2)}`);

  if (!customElements.get('glow-bundles')) {
    class GlowBundles extends HTMLElement {
      connectedCallback() {
        this.section = this.dataset.section;
        this.pct = { 1: Number(this.dataset.single) || 0, 2: Number(this.dataset.duo) || 0, 3: Number(this.dataset.squad) || 0 };
        try { this.variants = JSON.parse(this.querySelector('[data-variants]').textContent); } catch (e) { this.variants = []; }
        this.form = doc.getElementById(`product-form-${this.section}`);
        this.idInput = this.form?.querySelector('input[name="id"]');
        this.qtyInput = this.querySelector('[data-tg-qty]');
        this.sizesBox = this.querySelector('.tg-bundles__sizes');
        this.rowsBox = this.querySelector('[data-rows]');
        this.picks = [];
        this.addEventListener('change', (e) => {
          if (e.target.matches('input[name^="tg-tier"]')) this.setTier(Number(e.target.value), true);
          if (e.target.matches('select[data-ball]')) {
            const i = Number(e.target.dataset.ball);
            this.picks[i] = { id: Number(e.target.value), touched: true };
            this.render();
          }
        });
        this.idInput?.addEventListener('change', () => this.onVariant());
        if (typeof subscribe === 'function') {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event?.data?.sectionId && !String(event.data.sectionId).includes(this.section)) return;
            this.onVariant();
          });
        }
        const preset = Number(new URLSearchParams(location.search).get('bundle'));
        const checked = this.querySelector('input[name^="tg-tier"]:checked');
        this.tier = [1, 2, 3].includes(preset) ? preset : Number(checked?.value) || 1;
        const radio = this.querySelector(`input[name^="tg-tier"][value="${this.tier}"]`);
        if (radio) radio.checked = true;
        this.setTier(this.tier, false);
      }
      disconnectedCallback() { this.unsub?.(); }
      currentVariant() {
        const id = Number(this.idInput?.value);
        return this.variants.find((v) => v.id === id) || this.variants.find((v) => v.available) || this.variants[0];
      }
      onVariant() {
        const v = this.currentVariant();
        if (!v) return;
        this.picks = this.picks.map((p) => (p.touched ? p : { id: v.id, touched: false }));
        this.render();
      }
      setTier(n, user) {
        this.tier = n;
        const v = this.currentVariant();
        while (this.picks.length < n) this.picks.push({ id: v?.id, touched: false });
        this.picks.length = n;
        this.picks[0] = { id: v?.id, touched: false };
        this.buildRows();
        this.render();
        if (user) emit('bundle_tier_select', { tier: n });
      }
      buildRows() {
        if (!this.rowsBox) return;
        this.sizesBox.hidden = this.tier < 2;
        this.rowsBox.innerHTML = '';
        if (this.tier < 2) return;
        this.picks.forEach((pick, i) => {
          const row = doc.createElement('label');
          row.className = 'tg-bundles__row';
          const span = doc.createElement('span');
          span.textContent = `Ball ${i + 1}`;
          const select = doc.createElement('select');
          select.dataset.ball = String(i);
          select.setAttribute('aria-label', `Size for ball ${i + 1}`);
          this.variants.forEach((v) => {
            const opt = doc.createElement('option');
            opt.value = v.id;
            opt.textContent = `${v.size} (${formatMoney(v.price)})${v.available ? '' : ' – sold out'}`;
            opt.disabled = !v.available;
            select.append(opt);
          });
          if (i === 0) select.disabled = true;
          row.append(span, select);
          this.rowsBox.append(row);
        });
      }
      priceOf(id) { return this.variants.find((v) => v.id === id)?.price || 0; }
      render() {
        const v = this.currentVariant();
        if (!v) return;
        this.querySelectorAll('select[data-ball]').forEach((s, i) => { if (this.picks[i]) s.value = this.picks[i].id; });
        /* The selected tier uses the real per-ball picks, so its card always matches the Add button. */
        const sel = this.totals();
        this.querySelectorAll('[data-tier-card]').forEach((card) => {
          const n = Number(card.dataset.tierCard);
          const full = n === this.tier ? sel.full : v.price * n;
          const total = n === this.tier ? sel.total : Math.round(full * (100 - this.pct[n]) / 100);
          card.querySelector('[data-total]').textContent = formatMoney(total);
          const was = card.querySelector('[data-was]');
          if (was) was.textContent = this.pct[n] ? formatMoney(full) : '';
          const per = card.querySelector('[data-per]');
          if (per) per.textContent = n > 1 ? `${formatMoney(Math.round(total / n))} per ball · save ${formatMoney(full - total)}` : per.dataset.default;
        });
        if (this.qtyInput) this.qtyInput.value = String(this.tier);
        this.updateAtc();
        emit('glow:bundle-change', this.snapshot());
      }
      /** Current selection, also read by <tg-sticky> when it connects after this element. */
      snapshot() {
        const v = this.currentVariant();
        return v ? { tier: this.tier, items: this.getItems(), total: this.totals().total, size: v.size } : null;
      }
      totals() {
        const full = this.picks.reduce((sum, p) => sum + this.priceOf(p.id), 0);
        const total = Math.round(full * (100 - this.pct[this.tier]) / 100);
        return { full, total, saved: full - total };
      }
      getItems() {
        const map = new Map();
        this.picks.forEach((p) => map.set(p.id, (map.get(p.id) || 0) + 1));
        return [...map].map(([id, quantity]) => ({ id, quantity }));
      }
      /* Returns items for a JSON /cart/add.js call only when sizes are mixed; otherwise Dawn's FormData path is used. */
      getCartItems() {
        const items = this.getItems();
        return items.length > 1 ? items : null;
      }
      label() {
        const { total } = this.totals();
        return this.tier > 1 ? `Add ${this.tier} balls — ${formatMoney(total)}` : `Add to cart — ${formatMoney(total)}`;
      }
      updateAtc() {
        const btn = doc.getElementById(`ProductSubmitButton-${this.section}`);
        if (!btn || btn.hasAttribute('disabled')) return;
        const span = btn.querySelector('span');
        if (span) span.textContent = this.label();
      }
    }
    customElements.define('glow-bundles', GlowBundles);
  }

  if (!customElements.get('tg-sticky')) {
    const KEYBOARD_GAP = 150;
    class TgSticky extends HTMLElement {
      connectedCallback() {
        this.section = this.dataset.section;
        this.state = { past: false, end: false, overlay: false, keyboard: false, ready: false };
        this.ac = new AbortController();
        this.obs = [];
        const opts = { signal: this.ac.signal };
        this.btn = this.querySelector('[data-sticky-atc]');
        this.price = this.querySelector('[data-sticky-price]');
        this.size = this.querySelector('[data-sticky-size]');
        this.btn?.addEventListener('click', () => this.submit(), opts);
        this.readyTimer = setTimeout(() => { this.state.ready = true; this.update(); }, 600);
        this.observe();
        doc.addEventListener('glow:bundle-change', (e) => this.sync(e.detail), opts);
        /* <glow-bundles> upgrades first and has already announced its state: read it now. */
        const bundles = doc.querySelector(`glow-bundles[data-section="${this.section}"]`);
        this.sync(bundles?.snapshot?.());
        this.mirror();
        window.addEventListener('resize', () => {
          if (this.shown) doc.documentElement.style.setProperty('--sticky-atc-offset', `${this.offsetHeight + 12}px`);
        }, { passive: true, signal: this.ac.signal });
      }
      disconnectedCallback() {
        clearTimeout(this.readyTimer);
        this.ac?.abort();
        this.obs?.forEach((o) => o.disconnect());
        if (this.shown) {
          doc.documentElement.style.setProperty('--sticky-atc-offset', '0px');
          doc.body.classList.remove('tg-sticky-on');
        }
      }
      mainButton() { return doc.getElementById(`ProductSubmitButton-${this.section}`); }
      watch(observer) { this.obs.push(observer); return observer; }
      observe() {
        const opts = { signal: this.ac.signal };
        const header = doc.querySelector('.section-header');
        const headerH = header ? header.offsetHeight : 0;
        const main = this.mainButton();
        if (main) {
          /* Show whenever the main button is off screen (above or below), read from geometry so fast jumps never leave it stale. */
          let queued = false;
          const check = () => {
            queued = false;
            const r = main.getBoundingClientRect();
            this.state.past = r.bottom < headerH || r.top > window.innerHeight;
            this.update();
          };
          const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(check); } };
          window.addEventListener('scroll', schedule, { passive: true, signal: this.ac.signal });
          window.addEventListener('resize', schedule, { passive: true, signal: this.ac.signal });
          check();
          this.watch(new MutationObserver(() => this.mirror())).observe(main, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
        }
        /* Hide near the final CTA and over the footer, so policy links are never covered. */
        const ends = doc.querySelectorAll('[data-final-cta], .footer');
        if (ends.length) {
          const inView = new Set();
          const endIO = this.watch(new IntersectionObserver((entries) => {
            entries.forEach((e) => (e.isIntersecting ? inView.add(e.target) : inView.delete(e.target)));
            this.state.end = inView.size > 0;
            this.update();
          }));
          ends.forEach((el) => endIO.observe(el));
        }
        const checkOverlay = () => {
          this.state.overlay = /overflow-hidden/.test(doc.body.className) || !!doc.querySelector('cart-drawer.active, dialog[open], glow-game details[open], #glow-game details[open]');
          this.update();
        };
        this.watch(new MutationObserver(checkOverlay)).observe(doc.body, { attributes: true, attributeFilter: ['class'] });
        doc.addEventListener('toggle', checkOverlay, { capture: true, signal: this.ac.signal });
        doc.addEventListener('close', checkOverlay, { capture: true, signal: this.ac.signal });
        const vv = window.visualViewport;
        vv?.addEventListener('resize', () => {
          /* Pinch-zoom also shrinks the visual viewport; only treat it as a keyboard at normal scale. */
          this.state.keyboard = vv.scale <= 1.01 && window.innerHeight - vv.height > KEYBOARD_GAP;
          this.update();
        }, opts);
      }
      update() {
        const s = this.state;
        const show = s.ready && s.past && !s.end && !s.overlay && !s.keyboard;
        if (show === this.shown) return;
        this.shown = show;
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        const h = show ? this.offsetHeight + 12 : 0;
        doc.documentElement.style.setProperty('--sticky-atc-offset', `${h}px`);
        doc.body.classList.toggle('tg-sticky-on', show);
        emit('glow:sticky', { visible: show });
        if (show) emit('sticky_atc_view', {});
      }
      sync(detail) {
        if (!detail) return;
        if (this.size && detail.size) this.size.textContent = detail.size;
        if (this.price) {
          this.price.textContent = detail.tier > 1 ? `${detail.tier} balls · ${formatMoney(detail.total)}` : formatMoney(detail.total);
        }
        doc.querySelectorAll('[data-sheet-size]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.sizePick === detail.size ? 'true' : 'false'));
      }
      /* Dawn disables the main button while a variant loads; only show "Sold out" when the main button says so. */
      mirror() {
        const main = this.mainButton();
        if (!main || !this.btn) return;
        const disabled = main.hasAttribute('disabled');
        const loading = main.classList.contains('loading');
        const mainText = main.querySelector('span')?.textContent.trim() || '';
        const s = window.variantStrings || {};
        const soldOut = disabled && (mainText === s.soldOut || mainText === s.unavailable);
        this.btn.toggleAttribute('disabled', disabled);
        this.btn.setAttribute('aria-busy', loading || (disabled && !soldOut) ? 'true' : 'false');
        this.btn.textContent = soldOut ? mainText : loading ? 'Adding…' : 'Add to cart';
      }
      submit() {
        const main = this.mainButton();
        if (!main || main.hasAttribute('disabled') || main.getAttribute('aria-disabled') === 'true') return;
        emit('sticky_atc_click', {});
        const form = doc.getElementById(`product-form-${this.section}`);
        if (!form) return;
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
    }
    customElements.define('tg-sticky', TgSticky);
  }
})();
